<template>
    <div @click="toPage(item)">
        <div class="section-card">
        <div class="header" :style="{backgroundColor: item.bgcolor }">
            <img v-if="item.icon == 'shop'" src="@assets/home/icon_shop.png" srcset="@assets/home/icon_shop@2x.png 2x" />
            <img v-if="item.icon == 'media'" src="@assets/home/icon_media.png" srcset="@assets/home/icon_media@2x.png 2x" />
            <img v-if="item.icon == 'tickets'" src="@assets/home/icon_tickets.png" srcset="@assets/home/icon_tickets@2x.png 2x" />
            <div :class="language == 'en' ? 'title-en' : ''">{{ item.title }}</div>
        </div>

        <div class="img-bg">
            <img :src="item.image_url" class="img">
        </div>

        <div class="btn" :class="language == 'en' ? 'btn-en' : ''">{{ item.button }}</div>
        </div>
    </div>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    const router = useRouter()

    const language = localStorage.getItem("language") || "zh"

    defineProps({
        item: { type: Object }
    })

    // 跳转到
    const toPage = (item) => {
        if (item.icon == 'shop') return router.push({ path : '/exhibitor'})
        if (item.icon == 'media') return router.push({ path : '/media'})
        if (item.icon == 'tickets') return router.push({ path : '/audience'})
    }

</script>

<style lang="scss" scoped>
        .section-card {
            background-color: #FFFFFF;
            color: #333;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 384px;
            height: 456px;
            border-radius: 30px;
            background-color: #FFFFFF;
            box-shadow: 0px 8px 18px 0px rgba(67, 67, 67, 0.18);
            cursor: pointer;
            overflow: hidden; 
            box-sizing: border-box;
            position: relative;

            .header {
                font-family: PingFangSC-medium;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 78px;
                background-color: #059669;
                color: #FFFFFF;
                font-weight: 500;
                font-size: 36px;
                letter-spacing: 3px;
                padding: 0 35px;
                width: calc(100% - 70px);

                .title-en {
                    font-size: 28px;
                }
            }
        }
        
        .header img {
            margin-right: 14px;
        }

        .img-bg {
            width: 100%;
            height: 270px;
            overflow: hidden;
        }
        .img {
            width: 100%;
            height: 270px;
            cursor: pointer;
            transition: all 0.3s ease-in-out;  
        }
        .img:hover {
            transform: scale(1.2);
        }
        .btn {
            width: 288px;
            height: 60px;
            border-radius: 33px;
            background-color: #F8FAFC;
            line-height: 28px;
            color: #333333;
            font-weight: 400;
            font-size: 24px;
            transition: all 0.3s ease-in-out;
            cursor: pointer;
            text-align: center;
            margin-top: 24px;
            align-items: center;
            justify-content: center;
            display: flex;
        }
        .btn:hover {
            font-family: PingFangSC-medium;
            color: #FFFFFF;
            font-weight: 500;
            background: linear-gradient(90deg, rgba(19, 94, 205, 1) 0%, rgba(12, 72, 161, 1) 100%);
        }

        .btn-en {
            font-size: 15px; 
        }

        // .section-card:hover {
            // border: 2px solid transparent;
            // transition: all 0.03s ease-in-out;
            // background: linear-gradient(134.1deg, rgba(158, 209, 255, 1) 0%, rgba(14, 80, 178, 1) 100%);
            /* CSS遮罩 */
                // mask: 
                //     linear-gradient(#fff 0 0) content-box, 
                //     linear-gradient(#fff 0 0);
                // mask-composite: exclude;   
            // border-radius: 30px !important;
            // border: 2px solid rgba(14, 80, 178, 1);
        // }

        /* 响应式布局 */
@media (max-width: 768px) {
        .section-card {
            width: 100%;
            height: 314px;
            border-radius: 8px;
            margin-bottom: 18px;

            .header {
                height: 32px;
                font-weight: 600;
                font-size: 14px;
                letter-spacing: 0px;
                padding: 0 12px;
                width: calc(100% - 24px);

                .title-en {
                    font-size: 14px;
                }

                img {
                    margin-right: 9px;
                    width: 14px;
                    height: 14px;
                }
            }
        }
        
        .img-bg {
            height: 218px;
        }

        .img {
            height: 218px;
        }

        .btn {
            width: 240px;
            height: 40px;
            border-radius: 25px;
            line-height: 40px;
            font-size: 14px;
            margin: 12px auto;
        }

        .btn-en {
            font-size: 14px; 
        }
}
</style>